import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from './models/dialog-data';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    imports: [MatCardModule, MatButtonModule, MatDialogClose]
})
export class ConfirmDialogComponent {
    dialogData: DialogData;
    title: string;
    message: string;

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {}

    // onConfirm(): void {
    //     // Close the dialog, return true
    //     this.dialogRef.close(true);
    // }

    // onDismiss(): void {
    //     // Close the dialog, return false
    //     this.dialogRef.close(false);
    // }
}
